export default "__VITE_ASSET__Dvr2I41I__"